import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { RestService } from '../../../shared/shared.module';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EulaComponent implements OnInit {

  public myTemplate: any = '';
  constructor(
    private restService: RestService,
  ) {
    this.restService.urlGet<string>('/assets/Documents/eula.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/landing/info/eula/eula.component.ts